export const INFLOW = {
    name: "In flow",
    value: "INFLOW"
}
export const OUTFLOW = {
    name: "Out flow",
    value: "OUTFLOW"
}
